import React, { useState } from "react";
import { Table, Button, Select, Pagination } from "antd";
import styles from "./ClientsTable.module.scss";
import {
  AiFillEdit,
  AiOutlineDelete,
  AiOutlineEye,
  AiOutlineFilter,
} from "react-icons/ai";

const mockData = Array.from({ length: 50 }, (_, i) => ({
  id: i + 1,
  email: `user${i + 1}@mail.com`,
  invitedBy: i % 2 === 0 ? `inviter${i}@mail.com` : "-",
  firstName: `First${i + 1}`,
  lastName: `Last${i + 1}`,
  registrationDate: new Date(2024, 1, i + 1).toLocaleDateString(),
  kycStatus: i % 3 === 0 ? "Verified" : "Pending",
  lastTimeOnline: new Date(2024, 1, i + 1).toLocaleDateString(),
  role: "Пользователь",
  aiCount: (Math.random() * 100).toFixed(0),
  reqCount: (Math.random() * 1000).toFixed(0),
  spent: (Math.random() * 500).toFixed(2),
  package: "Пробный",
}));

const ClientsTable = () => {
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [isActiveFilters, setIsFiltersAvtive] = useState(false);

  const columns = [
    { title: "ID", dataIndex: "id", key: "id" },
    { title: "Email", dataIndex: "email", key: "email" },
    { title: "Sponsor Email", dataIndex: "invitedBy", key: "invitedBy" },
    { title: "First Name", dataIndex: "firstName", key: "firstName" },
    { title: "Last Name", dataIndex: "lastName", key: "lastName" },
    {
      title: "Registration Date",
      dataIndex: "registrationDate",
      key: "registrationDate",
    },
    { title: "Status", dataIndex: "kycStatus", key: "kycStatus" },
    { title: "Роль", dataIndex: "role", key: "role" },
    { title: "Кол. AI ассистентов", dataIndex: "aiCount", key: "aiCount" },
    { title: "Тариф", dataIndex: "package", key: "package" },
    { title: "Кол. запросов AI", dataIndex: "reqCount", key: "reqCount" },

    {
      title: "Последний вход",
      dataIndex: "lastTimeOnline",
      key: "lastTimeOnline",
    },
    {
      title: "Actions",
      key: "actions",
      render: () => (
        <div className={styles.tableActions}>
          <button>
            <AiFillEdit size={16} />
          </button>

          <button>
            <AiOutlineEye size={16} />
          </button>
          <button>
            <AiOutlineDelete fill="red" size={16} />
          </button>
        </div>
      ),
    },
  ];

  return (
    <div>
      <div className={styles.tableHeader}>
        <button
          className={styles.tableFiltersButton}
          onClick={() => setIsFiltersAvtive(!isActiveFilters)}
        >
          Фильты <AiOutlineFilter size={18} fill="white" />
        </button>
        <input
          type="text"
          placeholder="Поиск"
          className={styles.tableFilterInput}
        />
      </div>
      <div
        className={styles.filtersContainer}
        style={{ height: isActiveFilters ? "100px" : "0px" }}
      >
        <input
          type="text"
          placeholder="Фильтр"
          className={styles.tableFilterInput}
        />
        <input
          type="text"
          placeholder="Фильтр"
          className={styles.tableFilterInput}
        />
        <input
          type="text"
          placeholder="Фильтр"
          className={styles.tableFilterInput}
        />
      </div>
      <Table
        columns={columns}
        dataSource={mockData.slice(
          (currentPage - 1) * pageSize,
          currentPage * pageSize
        )}
        pagination={false}
        rowKey="id"
      />
      <div className={styles.tableFooter}>
        <Select
          defaultValue={10}
          style={{ marginBottom: 10, width: 120 }}
          onChange={setPageSize}
        >
          <Select.Option value={5}>5</Select.Option>
          <Select.Option value={10}>10</Select.Option>
          <Select.Option value={15}>15</Select.Option>
          <Select.Option value={25}>25</Select.Option>
        </Select>
        <Pagination
          current={currentPage}
          total={mockData.length}
          pageSize={pageSize}
          onChange={setCurrentPage}
          showSizeChanger={false}
        />
      </div>
    </div>
  );
};

export default ClientsTable;
